// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"504":"06d0f356c3cb389d5221","732":"88ce78ab4d7f4e13812a"}[chunkId] + ".chunk.js";
};